import {ReactElement} from "react";
import {useDispatch, useSelector} from "react-redux";
import {IStore} from "@/redux/defaultStore";
import {Link, useLocation, useNavigate} from "react-router";
import {RiVipDiamondLine} from "react-icons/ri";
import {AiOutlineHeart, AiOutlineMenu, AiOutlineSearch} from "react-icons/ai";
import {FaChevronLeft} from "react-icons/fa";
import classNames from "classnames";
import {toggleSidebar} from "@/redux/meta/metaActions";
import {isIOSApp} from "@/utils/isGoNative";
import {MdEmojiPeople, MdOutlineShoppingBag} from "react-icons/md";
import {restaurantSearchRedirect} from "@/utils/restaurantSearchRedirect";
import { DEVOUR_RESTAURANT_ID } from "@/pages/restaurants/RestaurantPage";
import { isDesktop, isMobileOnly, isTablet } from "react-device-detect";
import { TbNotes } from "react-icons/tb";
import { BiRestaurant } from "react-icons/bi";

function DevourStickyFooter(): ReactElement {
    const location = useLocation();
    const dispatch = useDispatch();
    const lastSearchedPlaceId = useSelector((store: IStore) => store.metaStore.lastSearchedPlaceId);
    const fullToken = useSelector((store: IStore) => store.authStore.fullToken);
    const currentUser = useSelector((store: IStore) => store.metaStore.currentUser);
    const sidebarOpen = useSelector((store: IStore) => store.metaStore.sidebarOpen);
    const bottomNavHidden = useSelector((store: IStore) => store.metaStore.isBottomNavHidden);
    const navigate = useNavigate();
    const isModalActive = useSelector((store: IStore) => store.metaStore.activeModals);

    const getIsOnLandingPage = () => {
        return (location.pathname.includes("/restaurants") || location.pathname === "/") && !fullToken;
    };

    async function handleOrderFoodRouteForAuthedUser(): Promise<void> {
        if (getIsOnLandingPage()) {
            return;
        }
        dispatch(toggleSidebar(false));
        const redirectRoute = await restaurantSearchRedirect(currentUser?.user?.addresses, lastSearchedPlaceId);
        if (redirectRoute) {
            navigate(redirectRoute);
        } else {
            navigate("/restaurants");
        }

    }

    if (isModalActive !== 0) {
        return null;
    }

    return (
        <>
            {!bottomNavHidden &&
            <>
                {isIOSApp() &&
				    <button
				        className="devour-ios-back-button"
				        onClick={() => {
				            navigate(-1);
				        }}
				    >
				        <FaChevronLeft className="devour-ios-back-button_icon"/>
				    </button>
                }
                <div className="devour-sticky-footer">
                    <div className="devour-sticky-footer_content">
                        <Link
                            to="/go-vip-dashboard"
                            onClick={() => dispatch(toggleSidebar(false))}
                            className={classNames("devour-sticky-footer_link", {
                                "is-selected": location.pathname.includes("/go-vip-dashboard") && !sidebarOpen,
                            })}
                        >
                            <RiVipDiamondLine/>
                            <span className="devour-sticky-footer_link_text">
                                GoVIP
                            </span>
                        </Link>
                        <Link
                            to="/lootshop"
                            onClick={() => dispatch(toggleSidebar(false))}
                            className={classNames("devour-sticky-footer_link", {
                                "is-selected": location.pathname.includes("/lootshop") || location.pathname.includes(`/restaurants/${DEVOUR_RESTAURANT_ID}`) && !sidebarOpen,
                            })}
                        >
                            <MdOutlineShoppingBag/>
                            <span className="devour-sticky-footer_link_text">
                                {isMobileOnly ? "Shop" : "LootShop"}
                            </span>
                        </Link>
                        <button
                            onClick={() => dispatch(toggleSidebar(!sidebarOpen))}
                            className={classNames("devour-sticky-footer_button", {
                                "is-selected": sidebarOpen,
                            })}
                        >
                            <AiOutlineMenu/>
                            <span className="devour-sticky-footer_link_text">
                                Menu
                            </span>
                        </button>
                    </div>
                </div>
            </>
            }
        </>
    );
}

export default DevourStickyFooter;
